export default __webpack_public_path__ + "static/media/_plus-circle.1eb7b693.svg";